// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as ReactLazy$PorterinUtils from "../../../../../../../node_modules/@porterin/utils/src/utils/ReactLazy.mjs";
import * as ErrorBoundary$PorterinUtils from "../../../../../../../node_modules/@porterin/utils/src/error-boundary/ErrorBoundary.mjs";
import * as PnmErrorBoundary$PorterinFeature from "./campaign/PnmErrorBoundary.mjs";
import * as PnMHomePageShimmerCmp$PorterinFeature from "./pnm-shimmers/PnMHomePageShimmerCmp.mjs";

var PnmBookingFlowLazyCmp = {};

var Lazy = ReactLazy$PorterinUtils.MakeLazy(PnmBookingFlowLazyCmp);

function PnmBookingFlowLazyCmp$1(Props) {
  var sr_external_id = Props.sr_external_id;
  var user = Props.user;
  var hide_pnm_booking_flow = Props.hide_pnm_booking_flow;
  var LazyComp = Curry._3(Lazy.make, (function (param) {
          return import("./PnmBookingFlowCmpWrapper.mjs");
        }), (function (prim0, prim1, prim2, prim3, prim4) {
          var tmp = {
            sr_external_id: prim0,
            user: prim1,
            hide_pnm_booking_flow: prim2
          };
          if (prim3 !== undefined) {
            tmp.key = prim3;
          }
          return tmp;
        }), React.createElement(PnMHomePageShimmerCmp$PorterinFeature.make, {}));
  var onPnmModuleError = function (param) {
    return React.createElement(PnmErrorBoundary$PorterinFeature.make, {
                on_click_retry: (function (param) {
                    Curry._1(hide_pnm_booking_flow, undefined);
                  })
              });
  };
  return React.createElement(ErrorBoundary$PorterinUtils.make, {
              children: React.createElement(LazyComp.make, {
                    sr_external_id: sr_external_id,
                    user: user,
                    hide_pnm_booking_flow: hide_pnm_booking_flow
                  }),
              fallback: onPnmModuleError(undefined)
            });
}

var make = PnmBookingFlowLazyCmp$1;

export {
  PnmBookingFlowLazyCmp ,
  Lazy ,
  make ,
}
/* Lazy Not a pure module */
